<template>
  <el-container>
    <el-aside style="margin: 0 1vh 1vh 0; width: 460px">
      <el-card class="box-card" style="height: calc(100vh)">
        <div style="text-align: right" v-show="$model === '1'">
          当前用户: {{ userInfo.realName }}
          <a style="cursor: pointer" @click="logout">退出</a>
        </div>

        <panel-for-item title="基础设置">
          <div style="text-align: right" v-show="loadSnapStatus">
            当前方案: {{ currentSnapInfo.name }}
            <a style="cursor: pointer" @click="quitSnap">退出</a>
          </div>
          <el-row>
            <el-col :span="12">
              <el-cascader
                size="small"
                placeholder="选择曲线"
                :options="treeOptions"
                filterable
                v-model="chartSelect"
                :props="treeProps"
              ></el-cascader>
            </el-col>
            <el-col :span="12">
              <el-select
                v-model="time_type_ctl"
                @change="timeTypeChange"
                :disabled="loadSnapStatus"
                size="small"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in timeGroupOption"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value2"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-show="$model === '1'">
              <el-select
                v-model="calied_type_ctl"
                :disabled="loadSnapStatus"
                size="small"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in data_calied_types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-autocomplete
                size="small"
                class="inline-input"
                v-model="searchVal"
                :fetch-suggestions="querySearch"
                placeholder="请输入站点名称搜索.."
                :trigger-on-focus="true"
                @select="toPointStation"
              >
                <template slot-scope="{ item }">
                  <div class="name">{{ item.name }}</div>
                </template>
              </el-autocomplete>
            </el-col>
          </el-row>
        </panel-for-item>

        <panel-for-item title="地图设置">
          <div class="panel-content">
            <div style="margin: 0 0 10px 0; font-weight: bold">
              当前标记个数: {{ chooseStationChart.length }}
            </div>
            <el-select
              v-model="data_type_ctl"
              @change="dataTypeChange"
              size="small"
              placeholder="请选择"
              style="width: 150px"
            >
              <el-option
                v-for="item in tpOptionsGetter"
                :title="item.title"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-show="isShow029"
              v-model="channels"
              size="small"
              placeholder="请选择"
              style="width: 150px"
            >
              <el-option
                v-for="item in option029"
                :title="item.title"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <mapStyleControl
              :map="map"
              v-if="!$route.query.map"
              style="width: 150px"
            ></mapStyleControl>
          </div>

          <div class="panel-content">
            <div class="control">
              <div class="main-control">
                <el-checkbox v-model="showWz">微站</el-checkbox>
              </div>
              <div class="extra-control" v-show="showWz">
                <div>
                  <el-checkbox v-model="showOff" style="display: inline-block"
                    >显示离线设备</el-checkbox
                  >
                  <el-checkbox v-model="showName" style="display: inline-block"
                    >显示微站名称</el-checkbox
                  >
                </div>
                <div>
                  <el-checkbox
                    v-model="showCurrentStation"
                    style="display: inline-block"
                    >标记当前微站</el-checkbox
                  >
                  <el-checkbox
                    v-model="showCurrentStationOnly"
                    style="display: inline-block"
                    >只显示当前微站</el-checkbox
                  >
                </div>
                <div>
                  <el-checkbox
                    v-model="showStationTable"
                    style="display: inline-block"
                    >显示微站表格</el-checkbox
                  >
                </div>
                <div>
                  <el-checkbox v-model="stationFilter" @change="geneMapData"
                    >只显示指定设备</el-checkbox
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="stationFilterVisable = true"
                    >指定设备</el-button
                  >
                </div>

                <div
                  v-show="$model == 1"
                  style="display: inline-block"
                  class="lipu"
                >
                  <el-checkbox
                    v-model="showLipuChart"
                    style="display: inline-block"
                    >叠加粒谱</el-checkbox
                  >
                  <el-radio class="lipu" v-model="lipuValue" label="6"
                    >6通道</el-radio
                  >
                  <el-radio v-model="lipuValue" label="31">31通道</el-radio>
                  <div>
                    <el-input
                      placeholder="请输入阈值"
                      v-model="inputValue"
                      size="mini"
                      style="width: 30%; display: inline-block"
                    ></el-input>
                    <el-button type="primary" size="mini" @click="yuzhiChange"
                      >提交</el-button
                    >
                    <el-button type="primary" size="mini" @click="resetYuzhi"
                      >恢复</el-button
                    >
                  </div>
                </div>
                <div>
                  <el-checkbox
                    v-show="$model == 1"
                    v-model="showStationTableDiff"
                    style="display: inline-block"
                    >微站偏差表格</el-checkbox
                  >
                </div>
                <div>
                  粒径系数
                  <el-slider
                    :max="10"
                    :step="0.1"
                    v-model="point_size_rate"
                    show-input
                  ></el-slider>
                </div>

                <div>
                  <el-checkbox
                    v-show="$model == 1"
                    v-model="showOtherProjectStation"
                    style="display: inline-block;"
                    >叠加其他项目微站</el-checkbox
                  >
                  <el-select
                    v-show="showOtherProjectStation"
                    v-model="otherGroupId"
                    size="small"
                    placeholder="请选择"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in serverGroups"
                      :title="item.name"
                      :key="item.group_id"
                      :label="item.name"
                      :value="item.group_id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="control">
              <div class="main-control">
                <el-checkbox v-model="showGf" @change="drawGf"
                  >标站</el-checkbox
                >
              </div>
              <div class="extra-control" v-show="showGf">
                <div>
                  <!-- <el-select :disabled="!showGf" v-model="gf_level" @change="getGfData" size="mini" placeholder="请选择">
                    <el-option
                      v-for="item in gfOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select> -->

                  <el-select
                    v-model="selectLevels"
                    :disabled="!showGf"
                    multiple
                    size="small"
                    style="min-width: 200px; margin-top: 10px"
                    @change="getGfData"
                    data-label="gf_choose"
                  >
                    <el-option
                      v-for="i in capStationType"
                      :key="i"
                      :label="i"
                      :value="i"
                    >
                      {{ i }}
                    </el-option>
                  </el-select>

                  <el-select
                    :disabled="!showGf"
                    v-model="pollutionIndexType"
                    size="mini"
                    v-if="isPollution"
                  >
                    <el-option
                      v-for="item in pollutionIndexTypes"
                      :title="item.title"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div>
                  <el-checkbox
                    v-model="showGFName"
                    style="display: inline-block; height: 3vh"
                    >显示标站名称</el-checkbox
                  >
                  <el-checkbox v-model="showGfOutline"
                    >显示离线标站</el-checkbox
                  >
                </div>

                <div>
                  <el-checkbox v-model="isShowCircle" @change="showCircle"
                    >显示标站周边</el-checkbox
                  >
                  <el-input-number
                    size="mini"
                    v-model="circleRVal"
                    :controls="false"
                    @change="handleCircleRoundValueChange"
                    :min="1"
                    :max="10000"
                  ></el-input-number>
                  米
                  <el-checkbox v-model="showGfStationTable"
                    >标站表格</el-checkbox
                  >
                </div>

                <el-button type="primary" size="mini" @click="exportCircle"
                  >导出标站周边</el-button
                >
              </div>
            </div>

            <div class="control">
              <div class="main-control" v-show="pollution_track != 1">
                <el-checkbox v-model="showCarLayer">走航云图</el-checkbox>
              </div>
              <div v-show="showCarLayer" class="extra-control">
                走航云图车次过滤:
                <!-- <el-input size="mini" style="width: 60px" v-model="car_point_filter"></el-input>  -->
                <el-input-number
                  size="mini"
                  v-model="car_point_filter"
                  controls-position="right"
                  :min="1"
                  :max="500"
                ></el-input-number>
              </div>
            </div>

            <div class="control">
              <div class="main-control">
                <el-checkbox
                  v-model="showGridLineLayer"
                  :disabled="data_type !== 'pm25' && data_type !== 'pm10'"
                  >热点网格</el-checkbox
                >
              </div>
              <div v-show="showGridLineLayer" class="extra-control">
                <el-checkbox
                  v-model="showGridName"
                  style="display: inline-block; height: 3vh"
                  >显示热点网格名称</el-checkbox
                >
                <div>
                  <span class="demonstration">网格透明度</span>
                  <el-slider v-model="gridOpacity"></el-slider>
                </div>
              </div>
            </div>

            <div class="control">
              <div class="main-control">
                <el-checkbox v-model="showWindLayer">风场</el-checkbox>
              </div>
              <div class="extra-control">
                <div class="block">
                  <span class="demonstration">风场颜色</span>
                  <el-color-picker
                    size="small"
                    v-model="colors"
                  ></el-color-picker>
                </div>
              </div>
            </div>

            <div class="control" v-if="$model == 1 || pollution_track == 1">
              <div class="main-control">
                <el-checkbox style="margin-right: 10px;" v-model="showPolluteSourceLayer" :disabled="data_type != 'pm25' && data_type != 'pm10'">最近24小时污染源</el-checkbox>
                <el-button size="mini" @click="exportPollutionGrid">导出污染源</el-button>
              </div>
              <div class="main-control" style="margin-top: 5px;">
                <el-checkbox style="margin-right: 10px;" v-model="showGridInterpImg" :disabled="data_type != 'pm25' && data_type != 'pm10'">网格插值图</el-checkbox>

                透明度：<el-input-number size="mini" v-model="gridInterpImgTransparency" :min="0.1" :max="1" :step="0.1" label="描述文字"></el-input-number>
              </div>

              <div class="main-control" style="margin-top: 5px;">
                <el-checkbox style="margin-right: 10px;" v-model="trackMode" >Air-Tracker模式</el-checkbox>
                透明度：<el-input-number size="mini" v-model="trackTransparency" :min="0.1" :max="1" :step="0.1" label="描述文字"></el-input-number>
              </div>

              <div class="main-control">
                时间聚合：
                <el-switch
                  v-model="trackCustomTimeMode">
                </el-switch>

                <el-select v-model="trackTimeMode" size="small" style="width: 100px;">
                  <el-option label="所有时段" value="0"></el-option>
                  <el-option label="高值时段" value="1"></el-option>
                  <el-option label="低值时段" value="2"></el-option>
                </el-select>

                <el-date-picker
                  :disabled="!trackCustomTimeMode"
                  size="mini"
                  v-model="trackTimeRange"
                  type="datetimerange"
                  :picker-options="pickerOptions2"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH"
                  align="right"
                  style="width: 330px;"
                  >
                </el-date-picker>
              </div>
              

              <div class="main-control" style="margin-top: 5px;">
                <el-checkbox style="margin-right: 10px;" v-model="showAermodLayer" >Aermod</el-checkbox>
                <div v-show="showAermodLayer">
                  污染源范围：
                  <el-radio-group size="mini" v-model="aermodRoundType" >
                    <el-radio-button label="track">Stilt轨迹范围</el-radio-button>
                    <el-radio-button label="circle">圆形范围</el-radio-button>
                  </el-radio-group>
                </div>
                <div v-show="showAermodLayer" style="margin-top: 5px;">
                  半径：
                  <el-input-number
                    size="mini"
                    v-model="aermodCircleRound"
                    :controls="false"
                    :min="1"
                    :max="10000"
                    :disabled="aermodRoundType!=='circle'"
                  ></el-input-number>
                  米
                </div>
                
              </div>


              <levelsLayer v-if="map" :map="map" :data_type="data_type"></levelsLayer>
            </div>

            <el-row>
              <el-col :span="12" v-show="$model == 1">
                <el-checkbox v-model="showOldborder">显示老边界</el-checkbox>
              </el-col>
            </el-row>

            <!-- 风玫瑰图 -->
            <average-particle
              v-show="model == 1"
              :map="map"
              :max="colorMax"
              :min="colorMin"
              :colorType="colorType"
              :city="projectInfo.name"
              :offStations="offStations"
              :showOff="showOff"
            ></average-particle>

            <div>
              修改色条颜色最大值<el-slider
                :max="1000"
                :min="sliderMin"
                v-model="colorMax"
                show-input
              ></el-slider>
            </div>
            <div>
              修改色条颜色最小值<el-slider
                :max="1000"
                :min="sliderMin"
                v-model="colorMin"
                show-input
              ></el-slider>
            </div>

            <loadCsvFile
              v-show="$model == 1"
              @readFileFinished="readFileFinished"
            ></loadCsvFile>
          </div>
        </panel-for-item>

        <panel-for-item title="曲线设置">
          <el-row>
            <el-col :span="12">
              <el-checkbox
                v-model="showPollutionChart"
                @change="getPollutionIndexData"
                >局部污染指数</el-checkbox
              >
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="showGfChart" @change="drawGfChart"
                >标站均值曲线</el-checkbox
              >
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="showRegionChart" @change="drawRegionChart"
                >区域均值曲线</el-checkbox
              >
            </el-col>
            <el-col :span="12" v-show="$model == 1">
              <el-checkbox v-model="showDustIndex" @change="getRouteDustIndex"
                >道路扬尘指数</el-checkbox
              >
            </el-col>
            <el-col :span="12" v-show="$model == 1">
              <el-checkbox
                v-model="showDustIndexSummary"
                @change="getRouteDustIndexSummary"
                >道路扬尘散点指数</el-checkbox
              >
            </el-col>

            <el-col :span="24">
              局部污染指数系数:
              <el-slider
                :max="300"
                :min="1"
                v-model="ratio"
                show-input
                @change="setRatio"
              ></el-slider>
            </el-col>
          </el-row>
        </panel-for-item>
      </el-card>

      <station-table
        v-show="showStationTable"
        :tableData="map_data"
        @closeTable="showStationTable = false"
        :data_type="data_type"
        @toPoint="toPointStation"
      >
      </station-table>
      <StationDiffTable
        v-show="showStationTableDiff"
        :tableData="stationDiffData"
        @closeTable="showStationTableDiff = false"
        @toPoint="toPointStation"
      >
      </StationDiffTable>
      <gf-station-table
        v-show="showGfStationTable"
        :tableData="gf_data"
        :isPollution="isPollution"
        @closeTable="showGfStationTable = false"
        :data_type="data_type"
        @toPoint="toPointGf"
      >
      </gf-station-table>
    </el-aside>

    <el-main style="padding: 0; height: 100vh">
      <snapPanel v-show="$model == 1" @loadSnapShot="loadSnapShot"></snapPanel>

      <MapView
        ref="map_view"
        :height="mapHeight"
        :max="colorMax"
        :min="colorMin"
        :colorType.sync="colorType"
        :point_size_rate="point_size_rate"
        :map-type="map_type"
        :map-data="map_data"
        :gf-data="gf_data"
        :isShowCircle="isShowCircle"
        :circleR="circleR"
        :show-wind-layer="showWindLayer"
        :showPolluteSourceLayer="showPolluteSourceLayer"
        :showGridInterpImg="showGridInterpImg"
        :gridInterpImgTransparency="gridInterpImgTransparency"
        :show-car-layer="showCarLayer"
        :showWindRoseMap="showWindRoseMap"
        :chooseStationChart="chooseStationChart"
        :car_point_filter="car_point_filter"
        :grid1_child="grid1_child"
        :grid5_child="grid5_child"
        :gridDialogVisible="gridDialogVisible"
        :showWz="showWz"
        :showGfOutline="showGfOutline"
        :showOldborder="showOldborder"
        :windColor="colors"
        :showOff="showOff"
        :showName="showName"
        :showLipuChart.sync="showLipuChart"
        :lipuValue="lipuValue"
        :showCurrentStation="showCurrentStation"
        :showGFName="showGFName"
        :showGridName="showGridName"
        :gridOpacity="gridOpacity"
        :isPollution="isPollution"
        :channels="channels"
        :offStations.sync="offStations"
        :trackMode="trackMode"
        :trackTransparency="trackTransparency"
        :trackCustomTimeMode="trackCustomTimeMode"
        :trackTimeRange="trackTimeRange"
        :trackTimeMode="trackTimeMode"

        :showAermodLayer="showAermodLayer"
        :aermodRoundType="aermodRoundType"
        :aermodCircleRound="aermodCircleRound"
        
        @map="mapf"
        @openMapWindowGrid="openMapWindowGrid"
        @chooseStationChartChange="chooseStationChartChange"
      ></MapView>

      <div v-show="!loadSnapStatus">
        <div style="height: 1vh; background: #ffffff"></div>

        <div style="display: inline-block; position: absolute; right: 10px">
          <i
            v-show="showChart"
            @click="changeChart(false)"
            style="font-size: 40px"
            class="el-icon-arrow-down"
          ></i>
          <i
            v-show="!showChart"
            @click="changeChart(true)"
            style="font-size: 40px"
            class="el-icon-arrow-up"
          ></i>
        </div>

        <main-chart
          v-show="showChart"
          ref="main_chart"
          height="calc(29vh - 55px)"
          :time_type="time_type"
          @initChart="initChart"
          @changeTimeT="changeTimeT"
          @handleChartTypeChange="handleChartTypeChange"
        >
        </main-chart>
      </div>
    </el-main>

    <el-dialog
      title="设备过滤显示"
      :visible.sync="stationFilterVisable"
      @close="closeStationFilter"
    >
      <station-filter
        @chooseStationFilterList="chooseStationFilterList"
        :stationFilterVisable="stationFilterVisable"
      ></station-filter>
    </el-dialog>

    <GridDialog
      class="cus_dialog"
      v-if="gridDialogVisible"
      :station="chooseGrid"
      :stations="stations"
      :data-type="data_type"
      :time-type="time_type"
      @closeWindow="closeWindow"
    >
    </GridDialog>
  </el-container>
</template>

<script>
import { GetQueryString, GetRequest, isCheckNumber } from "@/utils/util";
import { mapState, mapGetters } from "vuex";
import {
  pickerOptions2,
  timeGroupOption,
  gf_level_options,
  name_options,
  chartColors,
  channels31Values,
  channels6Values
} from "../options/option";
import {
  getProfile,
  getStations,
  getVirtualStations,
  getGfStations,
  getStationDataTimeSlot,
  getStationData,
  getTimeStationData,
  getStationCurrentData,
  getAlarmLogs,
  getEvents,
  getGrids,
  getPmcolorRatio,
  getStationByVir,
  getRouteDustIndex,
  getGfAvg,
  getGfStationData,
  getStationDiff,
  GetCalGroupStations,
  getCalGroups,
  getSnapshotData,
  getStationPollutionIndex,
  get029Wz
} from "@/api/api";
import { check_time_range, lineDataTo24H } from "@/utils/util";
import MapView from "@/components/MapView";
import MainChart from "@/components/MainChart";
import ExportData from "@/components/ExportData";
import StationFilter from "@/components/StationFilter";
import GridDialog from "@/components/GridDialog.vue";
import mapStyleControl from "@/components/mapStyleControl.vue";
import PanelForItem from "@/components/common/PanelForItem";
import StationTable from "@/components/common/StationTable";
import StationDiffTable from "@/components/common/StationDiffTable";
import GfStationTable from "@/components/common/GfStationTable";
import loadCsvFile from "@/components/common/loadCsvFile";
import snapPanel from "@/components/common/snapPanel";
import moment from "moment";
import FileSaver from "../utils/FileSaver";
import AverageParticle from "@/components/AverageParticle";
import levelsLayer from '@/components/edf/levelsLayer'

const channels6Option = G_SENSOR_DATA_TYPE_INFO.filter(item =>
  channels6Values.includes(item.value)
);
const channels31Option = G_SENSOR_DATA_TYPE_INFO.filter(item =>
  channels31Values.includes(item.value)
);

export default {
  name: "Home",
  data() {
    return {
      pickerOptions2,
      inputValue: null,
      showPollutionChart: true,
      showWz: true,
      showWindRoseMap: false,
      car_point_filter: 1,
      map_type: "point",
      mainChartType: "pm10",
      treeProps: {
        value: "station_id",
        label: "name"
      },
      chartSelect: ["-1", 2903],
      current_data: [],
      map_data: [],
      gf_data: [],
      point_size_rate: 1,
      showGfChart: false,
      showRegionChart: false,
      showGf: false,
      showGridLineLayer: false,
      showGridLayer: false,
      showStationTable: false,
      showGfStationTable: false,
      showStationTableDiff: false,
      showLipuChart: false, // 显示粒谱
      showOtherProjectStation: false,
      map: "",
      ratio: 1,
      data_calied_types: [
        { label: "动态校准", value: 1 },
        { label: "原始数据", value: 0 },
        { label: "单设备校准", value: 2 }
      ],
      gfOptions: [
        { label: "国控点", value: "国" },
        { label: "省控点", value: "省" },
        { label: "市控点", value: "市" },
        { label: "街镇控点", value: "街镇" }
      ],
      pollutionIndexTypes: [
        {
          label: "全市背景值",
          value: "_index_0",
          title: "全市均值为背景值的污染指数"
        },
        {
          label: "周边30公里背景值",
          value: "_index_1",
          title: "周围30公里站点数据均值为背景值的污染指数"
        }
      ],
      pollutionIndexType: "_index_1",
      stationPollution: [],
      gf_level: "国",
      selectLevels: ["国"],
      pollution: "",
      chart: "",
      pollutionData: [],
      colorMax: 700,
      colorMin: 0,
      sliderMin: 0,
      hour: 0,
      colorType: "static",

      gf_station_data: [],
      chooseStationChart: [],
      stationFilterList: [],
      stationFilter: false,
      chartData: [],
      showWindLayer: false,
      showCarLayer: false,
      stationFilterVisable: false,
      gridDialogVisible: false,
      chooseGrid: "",
      grid1_child: null,
      grid5_child: null,
      stafilter: false,
      showGfOutline: false,
      showOldborder: false,
      showDustIndex: false,
      showDustIndexSummary: false,
      isShowCircle: false,
      circleR: 2000,
      circleRVal: 2000,
      colors: "#409EFF",

      showOff: false,
      showName: true,
      showCurrentStation: false,
      showCurrentStationOnly: false,
      showGridName: true,
      gridOpacity: 70,
      showGFName: true,
      stationDiffData: [],
      searchVal: "",
      // 显示粒谱
      lipuValue: "31",
      channels: "",

      offStations: [],
      model: 0,
      otherGroupId: null,
      showPolluteSourceLayer: false,
      showGridInterpImg: false,
      trackMode: false,
      gridInterpImgTransparency: 1,
      trackTransparency: 0.6,

      trackCustomTimeMode: false,
      trackTimeMode: "0",
      trackTimeRange: [moment().subtract(7, 'days').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")],

      showAermodLayer: false,
      aermodRoundType: 'circle',
      aermodCircleRound: 3000
    };
  },
  components: {
    PanelForItem,
    MapView,
    MainChart,
    ExportData,
    StationFilter,
    GridDialog,
    mapStyleControl,
    StationTable,
    GfStationTable,
    loadCsvFile,
    StationDiffTable,
    snapPanel,
    AverageParticle,
    levelsLayer
  },
  mounted() {
    this.model = GetRequest("model");
    this.initPage();
  },
  watch: {
    showOtherProjectStation() {
      if (this.showOtherProjectStation && this.otherGroupId) {
        this.$store
          .dispatch(
            "getStations",
            this.userInfo.devGroupIds + "," + this.otherGroupId
          )
          .then(() => {
            this.clickLine();
          });
      } else {
        this.$store
          .dispatch("getStations", this.userInfo.devGroupIds)
          .then(() => {
            this.clickLine();
          });
      }
    },
    otherGroupId() {
      this.$store
        .dispatch(
          "getStations",
          this.userInfo.devGroupIds + "," + this.otherGroupId
        )
        .then(() => {
          this.clickLine();
        });
    },
    selectLevels() {
      this.$store.commit("setSelectLevels", this.selectLevels);
    },
    pollutionIndexType() {
      this.handleStationData();
    },
    line_t() {
      console.log("linet change");
      this.clickLine();
    },
    showStationTable() {
      if (this.showStationTable) {
        this.showGfStationTable = false;
      }
    },
    showGfStationTable() {
      if (this.showGfStationTable) {
        this.showStationTable = false;
      }
    },
    showStationTableDiff() {
      if (this.showStationTableDiff) {
        this.getStationDiff();
      }
    },
    current_data() {
      this.geneMapData();
    },
    showCurrentStationOnly() {
      this.geneMapData();
    },
    chartSelect() {
      console.log("chartSelect change");

      let stations = [];
      let station_type = this.chartSelect[0];
      let station_id = this.chartSelect[1];
      console.log(station_type);
      if (station_type == "-3") {
        let chooseStation = this.$_.find(this.stations, function(x) {
          return x.station_id == station_id;
        });
        this.$refs.map_view.openMapWindowStation(chooseStation);
        this.chooseStationChart = [chooseStation];
      }
      if (station_type == "-1") {
        var vir_name = this.$_.find(this.vir_stations, function(x) {
          return x.station_id == station_id;
        }).group_id;
        this.chooseStationChart = this.$_.filter(this.stations, function(x) {
          return x.id2 == vir_name || x.id3 == vir_name;
        });
      }
      if (station_type == "-2") {
        var vir_name = this.$_.find(this.vir_stations, function(x) {
          return x.station_id == station_id;
        }).group_id;
        this.chooseStationChart = this.$_.filter(this.stations, function(x) {
          return x.id3 == vir_name || x.id2 == vir_name;
        });
      }
      if (
        station_type == "-4" ||
        station_type == "-5" ||
        station_type == "-6"
      ) {
        getStationByVir(station_id).then(ids => {
          this.chooseStationChart = this.$_.filter(this.stations, function(x) {
            return ids.indexOf(x.station_id) != -1;
          });
        });
      }
      if (station_type === "-7") {
        GetCalGroupStations(station_id).then(x => {
          let ids = x.data.map(i => i.ID);
          this.chooseStationChart = this.$_.filter(this.stations, function(x) {
            return ids.indexOf(x.station_id) != -1;
          });
        });
        return;
      }
      this.getPollutionIndexData();
      this.drawRegionChart();
    },
    showGridLayer() {
      if (this.showGridLayer) {
        this.showGridLineLayer = false;
        this.map_type = "grid";
      } else {
        this.map_type = "point";
      }
    },
    showGridLineLayer() {
      this.gridLayerChange();
    },
    timeRange() {
      console.log("timeRange change");
      this.getPollutionIndexData();
      this.drawGfChart();
      this.drawRegionChart();
      this.getRouteDustIndex();
      this.getRouteDustIndexSummary();
    },
    mainChartType() {
      console.log("mainChartType change");
      this.getPollutionIndexData();
      this.drawGfChart();
      this.drawRegionChart();
      this.getRouteDustIndex();
      this.getRouteDustIndexSummary();
    },
    calied_type() {
      this.clickLine();
    },
    channels() {
      this.clickLine();
    }
  },
  computed: {
    ...mapState([
      "userInfo",
      "projectInfo",
      "stations",
      "station_dict",
      "vir_stations",
      "gf_stations",
      "treeOptions",
      "pmcolor_ratio",
      "zhGroupInfo",
      "timeRange",
      "line_t",
      "chartTypeStore",
      "data_type",
      "time_type",
      "calied_type",
      "loadSnapStatus",
      "currentSnapInfo",
      "showChart",
      "capStationType",
      "serverGroups",
      "pollution_track"
    ]),
    ...mapGetters(["tpOptionsGetter", "lineTStr"]),
    timeGroupOption() {
      if (this.pollution_track == 1) {
        return timeGroupOption.filter(i => i.value2 !== "min");
      } else {
        return timeGroupOption;
      }
    },
    mapHeight() {
      if (this.loadSnapStatus) {
        return "99vh";
      }
      if (this.showChart) {
        return "70vh";
      } else {
        return "94vh";
      }
    },
    data_type_ctl: {
      get() {
        return this.data_type;
      },
      set(v) {
        this.$store.commit("setDataType", v);
      }
    },
    time_type_ctl: {
      get() {
        return this.time_type;
      },
      set(v) {
        // 添加月和年，自动选择时间范围
        if (v === 'month') {
          this.$store.commit("setTimeRange", [moment().subtract(5, 'months').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")])
        }
        if (v === 'year') {
          this.$store.commit("setTimeRange", [moment().subtract(3, 'years').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")])
        }
        this.$store.commit("setTimeType", v);
      }
    },
    calied_type_ctl: {
      get() {
        return this.calied_type;
      },
      set(v) {
        this.$store.commit("setCaliedType", v);
      }
    },
    zoom() {
      if (this.map) {
        return this.map.getZoom();
      } else {
        return 0;
      }
    },
    chooseRegionName() {
      for (let i of this.vir_stations) {
        if (i.station_id == this.chartSelect[1]) {
          return i;
        }
      }
      for (let i of this.stations) {
        if (i.station_id == this.chartSelect[1]) {
          return i;
        }
      }
      return {};
    },
    isPollution() {
      if (this.data_type.indexOf("pollution") !== -1) {
        return true;
      } else {
        return false;
      }
    },
    option029() {
      if (this.data_type_ctl === "channels6") {
        return channels6Option;
      } else {
        return channels31Option;
      }
    },
    isShow029() {
      return this.data_type_ctl.includes("channels");
    }
  },

  methods: {
    exportPollutionGrid() {
      this.$refs.map_view.exportPollutionGrid()
    },
    handleCircleRoundValueChange(v) {
      this.circleR = v;
    },
    yuzhiChange() {
      this.$store.commit("setyuzhi", parseInt(this.inputValue));
      if (this.inputValue && this.showLipuChart) {
        this.$refs.map_view.changLipuChartShow();
      } else {
        this.$message({
          message: '请勾选"叠加粒谱"复选框并输入数值',
          type: "error"
        });
      }
    },
    resetYuzhi() {
      this.$store.commit("setyuzhi", null);
      this.$refs.map_view.changLipuChartShow();
      this.inputValue = null;
    },
    initPage() {
      if (this.$route.query.map) {
        this.colors = "#005cbb";
      }
      this.chartSelect = [
        "-1",
        this.treeOptions[0]["children"][0]["station_id"]
      ];
      this.$refs.main_chart.initChart();
    },
    logout() {
      this.$logout();
      // sessionStorage.removeItem(this.$app_id + '_yc_token')
      // this.$store.commit("setToken", null)
      // this.$router.replace({name: 'login'})
    },
    quitSnap() {
      this.$store.commit("setLoadSnapStatus", false);
      this.$store.commit("setCurrentSnapInfo", {});
      this.$store.commit("setCaliedType", 1);
      this.$store.commit("setTimeType", "hour");
      this.$store.commit("setDataType", "pm10");

      this.getPollutionIndexData();
    },
    querySearch(queryString, cb) {
      var results = queryString
        ? this.map_data.filter(x => {
            return x.name.indexOf(queryString) != -1;
          })
        : this.map_data;
      // 调用 callback 返回建议列表的数据
      results = results.slice(0, 5);
      cb(results);
    },
    handleSelect(item) {
      console.log(item);
    },
    gridLayerChange() {
      if (
        this.data_type !== "pm25" &&
        this.data_type !== "pm10" &&
        this.showGridLineLayer
      ) {
        this.$message("请在PM2.5或PM10图层下叠加网格");
        // this.$refs.map_view.removeGrid()
        this.showGridLineLayer = false;
        return;
      }
      if (this.showGridLineLayer) {
        this.$refs.map_view.initGrid(true);
      } else {
        this.$refs.map_view.removeGrid();
        this.closeWindow();
      }
    },
    showCircle(e) {
      this.isShowCircle = e;
    },
    readFileFinished(d) {
      this.map_data = d;
    },

    mapDataFilter(data) {
      console.log("mapDataFilter");
      return data.filter(i => {
        if (this.stationFilter) {
          if (this.stationFilterList.indexOf(i.name) == -1) {
            return false;
          }
        }
        if (this.showCurrentStationOnly) {
          let isChoose = this.chooseStationChart.find(x => {
            return x.station_id == i.station_id;
          });
          if (!isChoose) {
            return false;
          }
        }
        return true;
      });
    },
    geneMapData() {
      let map_data = [];
      if (this.current_data.length == 0) {
        this.map_data = [];
        return;
      }
      map_data = this.mapDataFilter(this.current_data);
      map_data = this.$_.sortBy(map_data, [
        function(x) {
          if (x.data[self.data_type]) {
            return x.data[self.data_type];
          } else {
            return -1;
          }
        }
      ]).reverse();
      console.log(map_data);
      this.map_data = map_data;
    },
    exportCircle() {
      let map = this.map;
      let data_type = this.data_type;
      let gf_data = this.gf_data;
      let map_data = this.map_data;
      let content = [],
        j = 1,
        avgValue = 0;
      content[0] = [`序号,微站名称, 标站数据, 标站周边均值\n`];
      for (let val of gf_data) {
        let pointSum = 0,
          i = 0;
        let point2 = new BMap.Point(val.Lng, val.Lat);
        let bzVlaue = val;
        for (let item of map_data) {
          let point1 = new BMap.Point(item.Lng, item.Lat);
          let distance = map.getDistance(point1, point2);
          if (distance <= this.circleR) {
            if (
              item.data &&
              item.data[data_type] &&
              item.data[data_type] != -1
            ) {
              pointSum = pointSum + item.data[data_type];
              i++;
            }
          }
        }
        if (pointSum === 0) {
          pointSum = 0;
        } else {
          pointSum = parseFloat(pointSum) / i;
        }
        let text = `${parseInt(j)},${val.name},${
          val.data[data_type]
        },${Math.round(pointSum * 10) / 10}\n`;
        content.push([text]);
        j++;
      }
      var file_name = data_type + "_" + "标站周边数据";
      var blob = new Blob(content, { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(blob, file_name + ".csv");
    },
    mapf(m) {
      this.map = m;
    },
    chooseStationChartChange(choose) {
      this.chooseStationChart = [choose];
    },
    changeChart(o) {
      if (o) {
        this.$store.commit("setShowChart", true);
      } else {
        this.$store.commit("setShowChart", false);
      }
    },
    timeTypeChange() {
      console.log("timeTypeChange");
      this.getPollutionIndexData();
      this.getRouteDustIndex();
      this.getRouteDustIndexSummary();
      this.drawGfChart();
      if (this.time_type == "day") {
        this.car_point_filter = 1;
        return;
      }
      if (this.time_type == "week") {
        this.car_point_filter = 7;
        return;
      }
      if (this.time_type == "month") {
        this.car_point_filter = 30;
        return;
      }
      this.car_point_filter = 1;
    },
    dataTypeChange(v) {
      if (this.data_type_ctl == "pm10_PoP") {
        this.sliderMin = -100;
        this.colorMin = -100;
        this.colorMax = 100;
      } else {
        this.sliderMin = 0;
        this.colorMin = 0;
        this.colorMax = 700;
      }
      
      this.channels = this.option029[0].value;

      this.point_size_rate = 1;
      if (this.loadSnapStatus) {
        this.loadSnapShot();
      } else {
        this.clickLine();
      }
      this.gridLayerChange();

      // this.getPollutionIndexData()
    },
    handleTreeChange(v) {
      this.chartSelect = v;
    },
    handleChartTypeChange(v) {
      this.mainChartType = v;
    },
    changeTimeT(o) {
      this.hour = o.hour;
      this.clickLine();
    },
    loadSnapShot() {
      this.current_data = [];
      let params = {
        group_id: this.userInfo.userId,
        name: this.currentSnapInfo.name,
        station_type: "wz",
        time: this.currentSnapInfo.data_time,
        time_type: this.currentSnapInfo.time_type,
        data_type: this.data_type
      };
      getSnapshotData(params).then(x => {
        let mapData = [];
        let data = x.data.data;
        let cols = data.columns;
        let vals = data.values;
        for (let i of vals) {
          let data_info = {
            data: {}
          };
          let idx = 0;
          for (let c of cols) {
            data_info[c] = i[idx];
            data_info.data[c] = i[idx];
            idx += 1;
          }
          data_info.Lng = data_info.lng;
          data_info.Lat = data_info.lat;
          data_info.name = data_info.station_name;
          mapData.push(data_info);
        }
        this.current_data = mapData;
      });
    },
    geneCurrentData(data) {
      var self = this;
      let current_data = [];
      let columns = data.columns || [];
      let values = data.values || [];
      if (!values.length) return [];
      let station_id_idx = columns.indexOf("station_id");
      for (let i of values) {
        let station_id = i[station_id_idx];
        let station_info = this.station_dict[station_id];
        if (!station_info) {
          continue;
        }
        let data = {};
        for (let c in columns) {
          data[columns[c]] = i[c];
        }
        station_info.data = data;
        current_data.push(station_info);
      }
      return current_data;
    },
    clickLine() {
      // this.current_data = []
      if (this.loadSnapStatus) {
        return;
      }
      this.chart.xAxis[0].removePlotLine("plot2");
      this.chart.xAxis[0].addPlotLine({
        color: "red",
        dashStyle: "solid",
        value: this.line_t,
        width: 2,
        id: "plot2"
      });
      let params = {},
        timeInterval_type;
      let data_type = this.data_type == 'pm10_PoP' ? 'pm10' : this.data_type;

      let L =
        this.timeRange &&
        moment(this.timeRange[1]).diff(this.timeRange[0], "days", false);
      if (L <= 7) {
        timeInterval_type = "week";
      } else {
        timeInterval_type = "month";
      }
      console.log(this.lineTStr);
      let params1 = {
        station_type: "wz",
        time: this.lineTStr,
        data_type: data_type,
        time_type: this.time_type,
        city: this.projectInfo.name,
        group_id: this.userInfo.devGroupIds,
        data_calied_type: this.calied_type
      };
      let params2 = {
        hour: this.hour,
        data_type: data_type,
        group_id: this.userInfo.devGroupIds,
        start_time: this.timeRange[0],
        time_type: timeInterval_type
      };
      console.log(params1, params2);
      if (this.chartTypeStore === "chart_24h") {
        params = params2;
        getTimeStationData(params)
          .then(x => {
            let x_data = x.data;
            if (this.data_type == "pm10_p") {
              params.data_type = "pm25";
              getStationData(params).then(y => {
                let y_data = y.data;
                let x_values = x_data.values;
                let y_values = y_data.values;
                x_data.columns.push("pm25");
                let station_id_idx = x_data.columns.indexOf("station_id");
                let pm25_idx = y_data.columns.indexOf("pm25");
                for (let i of x_values) {
                  let station_id = i[station_id_idx];
                  let y_filter = this.$_.find(y_values, function(f) {
                    return f[station_id_idx] == station_id;
                  });
                  i.push(y_filter[pm25_idx]);
                }
                this.current_data = this.geneCurrentData(x_data);
              });
            } else {
              this.current_data = this.geneCurrentData(x_data);
            }
          })
          .catch(e => {
            this.$message({
              message: "获取数据失败",
              type: "error"
            });
            this.current_data = [];
          });
      } else {
        params = params1;
        if (this.data_type_ctl.includes("channels")) {
          params.data_type = this.channels;
          this.get029Wz(params);
        } else {
          this.getStationData(params);
        }
      }
      if (this.showGf) {
        this.getGfData();
      }
    },
    getStationData(params) {
      if (this.otherGroupId) {
        params.group_id = params.group_id + "," + this.otherGroupId;
      }
      getStationData(params).then(x => {
        let x_data = x.data;
        if (this.data_type == "pm10_p") {
          params.data_type = "pm25";
          getStationData(params)
            .then(y => {
              let y_data = y.data;
              let x_values = x_data.values;
              let y_values = y_data.values;
              x_data.columns.push("pm25");
              let station_id_idx = x_data.columns.indexOf("station_id");
              let pm25_idx = y_data.columns.indexOf("pm25");
              for (let i of x_values) {
                let station_id = i[station_id_idx];
                let y_filter = this.$_.find(y_values, function(f) {
                  return f[station_id_idx] == station_id;
                });
                i.push(y_filter[pm25_idx]);
              }
              this.current_data = this.geneCurrentData(x_data);
            })
            .catch(e => {
              this.current_data = [];
              this.$message({
                message: "获取数据失败",
                type: "error"
              });
            });
        } else if (this.data_type == "pm10_PoP") {
          let time = this.$moment(params.time).subtract(1, "hours")
          if (this.time_type == "hour") {
            time = this.$moment(params.time).subtract(1, "hours")
          } else if (this.time_type == 'day') {
            time = this.$moment(params.time).subtract(1, "days")
          } else if (this.time_type == 'week') {
            time = this.$moment(params.time).subtract(1, "weeks")
          } else if (this.time_type == 'month') {
            time = this.$moment(params.time).subtract(1, "months")
          } else if (this.time_type == 'year') {
            time = this.$moment(params.time).subtract(1, "years")
          }
          let pre_params = { ...params, time: time.format("YYYY-MM-DD HH:mm:ss") };
          getStationData(pre_params).then(x => {
            let pre_data = x.data;
            x_data.columns.push("pm10_PoP");
            let station_id_idx = x_data.columns.indexOf("station_id");
            let pm10_idx = x_data.columns.indexOf("pm10");
            for(let i of x_data.values) {
              if (!isCheckNumber(i[pm10_idx])) {
                i.push(null);
                continue;
              }
              let station_id = i[station_id_idx];
              let pre_filter = this.$_.find(pre_data.values, function(f) {
                return f[station_id_idx] == station_id;
              });
              
              if (isCheckNumber(pre_filter[pm10_idx])) {
                i.push(Math.round((i[pm10_idx] - pre_filter[pm10_idx]) / pre_filter[pm10_idx] * 100))
              } else {
                i.push(null);
              }
            }
            this.current_data = this.geneCurrentData(x_data);
          })
          .catch(e => {
            this.current_data = [];
            this.$message({
              message: "获取数据失败",
              type: "error"
            });
          });
        } else {
          this.current_data = this.geneCurrentData(x_data);
        }
      });
    },
    get029Wz(params) {
      get029Wz(params)
        .then(x => {
          let x_data = x.data;
          if (this.data_type == "pm10_p") {
            params.data_type = "pm25";
            get029Wz(params).then(y => {
              let y_data = y.data;
              let x_values = x_data.values;
              let y_values = y_data.values;
              x_data.columns.push("pm25");
              let station_id_idx = x_data.columns.indexOf("station_id");
              let pm25_idx = y_data.columns.indexOf("pm25");
              for (let i of x_values) {
                let station_id = i[station_id_idx];
                let y_filter = this.$_.find(y_values, function(f) {
                  return f[station_id_idx] == station_id;
                });
                i.push(y_filter[pm25_idx]);
              }
              this.current_data = this.geneCurrentData(x_data);
            });
          } else {
            this.current_data = this.geneCurrentData(x_data);
          }
        })
        .catch(e => {
          this.current_data = [];
          this.$message({
            message: "获取数据失败",
            type: "error"
          });
        });
    },
    initChart(c) {
      this.chart = c.chart;
    },
    changeSelectRegion(v) {
      this.getPollutionIndexData();
      this.drawMap();
    },
    drawGf() {
      if (this.showGf) {
        this.getGfData();
      } else {
        this.gf_data = [];
      }
    },
    handleStationData() {
      let gf_data = [];
      for (let g of this.gf_stations) {
        if (this.stationFilter) {
          if (this.stationFilterList.indexOf(g.station) == -1) {
            continue;
          }
        }
        // gf_level_options[g.station_level] <= gf_level_options[this.gf_level]
        if (this.selectLevels.indexOf(g.station_level) !== -1) {
          let new_d = { time: "", station_id: "" };
          let data = {};
          // if (this.projectInfo.name === "济南市") {
          if (this.isPollution) {
            data = this.$_.find(this.stationPollution, function(o) {
              return o.sn == g.sn;
            });
            new_d[this.data_type] =
              data &&
              Math.round(
                data[
                  this.data_type.split("_pollution")[0].split("_f")[0] +
                    "_pollution" +
                    this.pollutionIndexType
                ] * 10
              ) / 10;
          } else {
            const data_type = this.data_type.split("_pollution")[0];
            data = this.$_.find(this.gf_station_data, function(o) {
              return o.sn == g.sn;
            });
            new_d[this.data_type] = data[data_type] || "--";
            new_d.time = data.data_time;
          }
          // } else {
          //   const data_type = this.data_type.split("_pollution")[0];
          //   data = this.$_.find(this.gf_station_data, function(o) {
          //     return o.sn == g.sn;
          //   });
          //   new_d[this.data_type] = data[data_type] || "--";
          //   new_d.time = data.data_time;
          // }
          if (!data) {
            data = {};
          }
          new_d.station_id = data.sn;
          /* for (let c in columns){
                new_d[columns[c]]=data[c]
                } */
          g.data = new_d;
          g["name"] = g.station.replace("办事处", "");
          gf_data.push(g);
        }
      }
      this.gf_data = gf_data;
    },
    async getGfData() {
      this.gf_station_data = await this.getGfStationData();
      if (this.isPollution) {
        this.stationPollution = await this.getStationPollutionIndex();
      }
      // let columns = x.data.columns
      this.handleStationData();
    },
    // 获取官方站数据
    getGfStationData() {
      const start_t = this.lineTStr;
      const end_t = this.lineTStr;
      const data_type = this.data_type.split("_pollution")[0];
      let params2 = {
        time: this.lineTStr,
        data_type: data_type,
        time_type: this.time_type,
        regionId: this.projectInfo.regionId
      };
      return getGfStationData(params2)
        .then(x => {
          console.log("获取官方站数据", x);
          let d = x.data.data;
          d.forEach(e => (e.co = e.co_f));
          return d;
        })
        .catch(err => {
          this.gf_data = [];
          console.log(err);
        });
    },
    // 获取标站污染指数数据
    getStationPollutionIndex() {
      return getStationPollutionIndex(this.lineTStr, this.time_type)
        .then(res => {
          const { status, message, data } = res;
          if (status === 0) {
            return data;
          } else {
            console.log("pollutionIndexHour接口返回：" + message);
          }
        })
        .catch(err => {
          this.gf_data = [];
        });
    },
    getPollutionIndexData() {
      console.log("getPollutionIndexData");
      let start_time = this.$moment(this.timeRange[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      let end_time = this.$moment(this.timeRange[1]).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      let data_type = this.mainChartType + "_pollution";

      let params1 = {
        start_time: start_time,
        end_time: end_time,
        data_type: data_type,
        time_type: this.time_type,
        station_id: this.chartSelect[1]
      };
      if (this.showPollutionChart) {
        getStationDataTimeSlot(params1)
          .then(d => {
            this.chartData = this.$_.cloneDeep(d);
            this.updateChart(1, {
              id: 1,
              name: name_options[data_type] + "_" + this.chooseRegionName.name,
              data: d,
              tooltip: { valueDecimals: 1 }
            });
            let find_res = d.find(x => {
              x[0] === this.line_t;
            });
            console.log(find_res);
            if (find_res) {
            } else {
              if (d.length) {
                let line_t = d[d.length - 1][0];
                this.$store.commit("setlineT", line_t);
              } else {
                this.$store.commit("setlineT", null);
              }
            }

            // this.clickLine()
          })
          .catch(e => {
            this.removeChart(1);
          });
      } else {
        this.removeChart(1);
      }
    },
    updateChart(id, seriesData) {
      seriesData.timetype = this.time_type;
      let chartColor = chartColors[id];
      seriesData.color = chartColor;
      if (this.chart.get(id)) {
        this.chart.update({
          series: [seriesData]
        });
      } else {
        this.chart.addSeries(seriesData);
      }
      this.$refs.main_chart.draw24hChart();
    },
    removeChart(id) {
      var c = this.chart.get(id);
      if (c) {
        c.remove();
      }
      this.$refs.main_chart.draw24hChart();
    },
    drawGfChart() {
      var self = this;
      let id = 3;
      if (this.showGfChart) {
        var t1 = this.timeRange[0];
        var t2 = this.timeRange[1];
        getGfAvg({
          time_type: this.time_type,
          start: t1,
          end: t2,
          gf_level: this.gf_level,
          data_type: self.mainChartType.slice(0, 4),
          region_id: this.projectInfo.regionId
        }).then(x => {
          var seriesData = x;
          this.updateChart(id, {
            id: id,
            name: name_options[self.mainChartType] + "_标站均值",
            data: seriesData,
            tooltip: { valueDecimals: 0 }
          });
        });
      } else {
        this.removeChart(id);
      }
    },
    drawRegionChart() {
      var self = this;
      let id = 2;
      if (this.showRegionChart) {
        let params1 = {
          start_time: this.timeRange[0],
          end_time: this.timeRange[1],
          data_type: this.mainChartType,
          time_type: this.time_type,
          station_id: this.chartSelect[1]
        };
        getStationDataTimeSlot(params1).then(d => {
          this.updateChart(id, {
            id: id,
            name:
              name_options[this.mainChartType] +
              "_" +
              this.chooseRegionName.name,
            data: d,
            tooltip: { valueDecimals: 0 }
          });
        });
      } else {
        this.removeChart(id);
      }
    },
    getRouteDustIndex() {
      let id = 4;
      if (this.showDustIndex) {
        getRouteDustIndex({
          start: this.timeRange[0],
          end: this.timeRange[1],
          data_type: this.mainChartType,
          time_type: this.time_type,
          group_id: this.zhGroupInfo.zh_group_id,
          host: this.zhGroupInfo.zh_host
        }).then(x => {
          this.updateChart(id, {
            id: id,
            name: name_options[this.mainChartType] + "_道路扬尘指数",
            data: x,
            tooltip: { valueDecimals: 1 }
          });
        });
      } else {
        this.removeChart(id);
      }
    },
    getRouteDustIndexSummary() {
      let id = 5;
      if (this.showDustIndexSummary) {
        getRouteDustIndex({
          start: this.timeRange[0],
          end: this.timeRange[1],
          data_type: this.mainChartType + "_summary_index",
          time_type: this.time_type,
          group_id: this.zhGroupInfo.zh_group_id,
          host: this.zhGroupInfo.zh_host
        }).then(x => {
          this.updateChart(id, {
            id: id,
            name: name_options[this.mainChartType] + "_道路扬尘散点指数",
            data: x,
            tooltip: { valueDecimals: 1 }
          });
        });
      } else {
        this.removeChart(id);
      }
    },
    drawChildGrid(info) {
      let r = info.r;
      let grid = info.grid;
      if (r == 1) {
        this.grid1_child = this.$_.filter(this.grids1, x => {
          return x.large_grid_box == grid.name;
        });
      } else {
        this.grid5_child = grid;
      }
    },
    closeWindow() {
      this.gridDialogVisible = false;
    },
    setRatio() {
      var seriesData = [];
      for (var i of this.chartData) {
        seriesData.push([i[0], i[1] * this.ratio]);
      }
      var pollution_chart = this.chart.get(1);
      pollution_chart.update({
        data: seriesData
      });
      this.$refs.main_chart.draw24hChart();
    },
    chooseStationFilterList(stationFilterList) {
      this.stationFilterVisable = false;
      this.stationFilterList = stationFilterList;
      this.geneMapData();
    },
    openMapWindowGrid(grid) {
      this.chooseGrid = grid;
      this.gridDialogVisible = true;
    },
    closeStationFilter() {
      this.stafilter = false;
    },
    toPointStation(station) {
      this.searchVal = station.name;
      this.$refs.map_view.openMapWindowStation(station);
    },
    toPointGf(station) {
      let pt = new BMap.Point(station.Lng, station.Lat);
      this.map.panTo(pt);
    },
    getStationDiff() {
      let start = this.$moment(this.timeRange[0]).format("YYYY-MM-DD HH:mm:ss");
      let end = this.$moment(this.timeRange[1]).format("YYYY-MM-DD HH:mm:ss");
      getStationDiff({ start, end }).then(x => {
        let d = x.data.data;
        this.stationDiffData = d;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-card__header {
  padding: 9px 20px;
  background: #f5f5f5;
}

.box-card {
  background: rgb(255, 255, 255);

  border-radius: 2px !important;
  overflow: auto !important;
}

.control {
  /*border-bottom: 1px solid black;*/
  padding-bottom: 10px;
}
.main-control {
}
.panel-content {
  margin: 10px 10px;
}
.extra-control {
  padding-left: 23px;
}
</style>
<style scoped>
.lipu >>> .el-radio {
  margin-left: 15px !important;
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue